export const omneaDataGridClasses = {
  roundTop: 'omnea-DataGrid--roundTop',
  roundBottom: 'omnea-DataGrid--roundBottom',
  roundHeaderRowTop: 'omnea-DataGrid--roundHeaderRowTop',
  roundPinnedLeftHeaderTop: 'omnea-DataGrid--roundPinnedLeftHeaderTop',
  roundFirstChildTop: 'omnea-DataGrid--roundFirstChildTop',
  allowPageScroll: 'omnea-DataGrid--allowPageScroll',
} as const
